import { useRef, useState } from "react";
import ForgeDice from "@/components/landing/ForgeDice";

const DICE = [
  {
    accentColor: "#ff3434",
    faces: ["CHIN-UPS", "PULL-UPS", "DIPS", "PIKE PUSH-UPS", "INVERTED ROWS", "BROAD JUMPS"],
  },
  {
    accentColor: "#3f82ff",
    faces: ["8 REPS", "6 REPS", "12 REPS", "20 SEC", "40 SEC", "1 MIN"],
  },
  {
    accentColor: "#9b6bff",
    faces: ["30 SEC REST", "15 SEC REST", "45 SEC REST", "1 MIN REST", "90 SEC REST", "WALK IT OFF"],
  },
];

export default function DiceScene() {
  const diceRef = useRef();
  const [results, setResults] = useState([0, 0, 0]);

  const roll = () => {
    setResults(DICE.map(() => Math.floor(Math.random() * 6)));
    diceRef.current?.roll();
  };

  return (
    <div className="w-full" data-testid="hero-dice-scene">
      <div className="relative w-full h-[360px] md:h-[430px]">
      <ForgeDice
        ref={diceRef}
        dice={DICE.map((d, i) => ({ ...d, resultIndex: results[i] }))}
        scheme="obsidian"
        scale={1}
        spread={1.3}
        glowEnabled
        glowStrength={0.5}
        animationDuration={1.6}
        testId="forge-dice"
      />

      </div>

      <div className="flex justify-center mt-8 md:mt-10">
      <button
        data-testid="hero-roll-btn"
        onClick={roll}
        className="display font-bold text-[14px] md:text-[15px] tracking-[0.3em] text-white px-10 py-4 rounded-full bg-forge border border-white/15 shadow-[0_14px_44px_rgba(255,52,52,0.45)] hover:bg-ember hover:-translate-y-1 hover:shadow-[0_18px_54px_rgba(238,101,51,0.55)] active:scale-95 transition-[transform,background-color,box-shadow] duration-300"
      >
        Roll the dice
      </button>
      </div>
    </div>
  );
}
